export enum LangType {
  Spanish = 1,
  English,
  Italian,
}

export function getLocaleFromLangType(lang: LangType): string {
  const localeMap: Record<LangType, string> = {
    [LangType.Spanish]: 'es',
    [LangType.English]: 'en',
    [LangType.Italian]: 'it',
  }

  return localeMap[lang] || 'es'
}
